import { Howl } from 'howler';

class AudioService {
  private sounds: Map<string, Howl> = new Map();
  private currentUrl: string | null = null;

  private getSound(url: string, loop: boolean): Howl {
    if (this.sounds.has(url)) {
      const sound = this.sounds.get(url)!;
      sound.loop(loop);
      return sound;
    }

    const newSound = new Howl({
      src: [url],
      loop,
      html5: true,
      onloaderror: (id, err) => {
        console.error('Error loading audio:', id, url, err);
      },
      onplayerror: (id, err) => {
        console.error('Error playing audio:', id, url, err);
      }
    });

    this.sounds.set(url, newSound);
    return newSound;
  }

  play(url: string, loop: boolean) {
    if (this.currentUrl && this.currentUrl !== url) {
      this.sounds.get(this.currentUrl)?.stop();
    }

    const sound = this.getSound(url, loop);
    sound.play();
    this.currentUrl = url;
  }

  pause() {
    if (this.currentUrl) {
      this.sounds.get(this.currentUrl)?.pause();
    }
  }

  resume() {
    if (this.currentUrl) {
      this.sounds.get(this.currentUrl)?.play();
    }
  }

  stop() {
    if (this.currentUrl) {
      this.sounds.get(this.currentUrl)?.stop();
      this.currentUrl = null;
    }
  }

  get isPlaying(): boolean {
    if (!this.currentUrl) return false;
    return this.sounds.get(this.currentUrl)?.playing() || false;
  }
}

export const audioService = new AudioService();
